import { KpiTypeTrendStackChart, SalesTypeTrendStackChart } from "@pages/explore/ExploreContants";
import { ColumnHeaderForCL } from "./CategoryLeaderboard";

export const trendedStackChartKpiDropdownOptions = [
  {
    label: KpiTypeTrendStackChart.MARKET_REVENUE,
    value: ColumnHeaderForCL.marketRevenue,
    salesType: SalesTypeTrendStackChart.VALUE,
  },
  {
    label: KpiTypeTrendStackChart.MARKET_UNITS,
    value: ColumnHeaderForCL.marketVolume,
    salesType: SalesTypeTrendStackChart.VOLUME,
  },
  {
    label: KpiTypeTrendStackChart.RETAILER_REVENUE,
    value: ColumnHeaderForCL.yourRevenue,
    salesType: SalesTypeTrendStackChart.VALUE,
  },
  {
    label: KpiTypeTrendStackChart.RETAILER_UNITS,
    value: ColumnHeaderForCL.yourVolume,
    salesType: SalesTypeTrendStackChart.VOLUME,
  },
];
export const getStackChartSalesType = (value: string) => { //Collecting the sales type via label
  return (
    trendedStackChartKpiDropdownOptions.find((item) => item.value === value)?.label ??
    trendedStackChartKpiDropdownOptions[0].label
  );
};